'use client';

import { captureException } from '@sentry/nextjs';
import type NextError from 'next/error';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: NextError;
  reset: () => void;
}) {
  useEffect(() => {
    captureException(error);
  }, [error]);
  return (
    // global-error must include html and body tags
    <html lang="en">
      <body>
        <h2>Something went wrong!</h2>
        <pre>{JSON.stringify(error, null, 2)}</pre>
        <button
          aria-label="Try again to reload the page"
          className="rounded-lg bg-light-blue px-4 py-2 font-semibold text-black hover:bg-light-blue/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-light-blue focus-visible:ring-offset-2"
          onClick={() => reset()}
          type="button"
        >
          Try again
        </button>
      </body>
    </html>
  );
}
